import { AnimatePresence } from "motion/react";
import { FC, PropsWithChildren } from "react";

import { ANIMATED_FADE_SWITCH_MOTION } from "@ryde/shared";

import {
  AnimatedFadeSwitchLayerStyled,
  AnimatedFadeSwitchViewportStyled,
} from "./animated-fade-switch.styled";
import { useAnimatedPage } from "./use-animated-page";

interface IAnimatedFadeSwitchProps extends PropsWithChildren {
  switchKey: string;
  durationSeconds?: number;
}

export const AnimatedFadeSwitch: FC<IAnimatedFadeSwitchProps> = ({
  switchKey,
  children,
  durationSeconds = ANIMATED_FADE_SWITCH_MOTION.enterDurationSeconds,
}) => {
  const { variants, transition } = useAnimatedPage({
    durationSeconds,
    exitDurationSeconds: ANIMATED_FADE_SWITCH_MOTION.exitDurationSeconds,
  });

  return (
    <AnimatedFadeSwitchViewportStyled>
      <AnimatePresence initial={false}>
        <AnimatedFadeSwitchLayerStyled
          key={switchKey}
          variants={variants}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={transition}
        >
          {children}
        </AnimatedFadeSwitchLayerStyled>
      </AnimatePresence>
    </AnimatedFadeSwitchViewportStyled>
  );
};
